<template>
  <div class="app-banner">
    <!-- Decorative dots -->
    <img src="@/assets/img/pattern-remove-pink.png" alt="Dotted Top Left" class="dotted dotted-top-left" />
    <img src="@/assets/img/pattern-remove-pink.png" alt="Dotted Bottom Right" class="dotted dotted-bottom-right" />
    
    <div class="banner-container">
      <img src="@/assets/img/how_it_works.png" alt="Nanny and Child" class="banner-image" />
      <!-- <div class="banner-content"> -->
     
          <div class="banner-text-box">
            <h4 class="banner-text-head">Care that works for everyone</h4>
            <p class="banner-text-desc">
              We've created a low-cost, self-service platform that
              puts families in control and values caregivers' real-life
              experience. Here's how NannyGranny works — simple
              steps to connect families who need support with women
              who are ready to give it.
            </p>
          </div>
        </div>
      </div>
   
</template>

<script>
export default {
  name: 'AppBanner'
}
</script>

<style scoped>
.app-banner {
  background-color: #08979d;
  position: relative;
  min-height: 400px;
  overflow: hidden;
}

.banner-container {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 40px 20px; */
  position: relative;
  z-index: 1;
}

.banner-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 350px;
}

.image-section {
  position: relative;
  width: 100%;
  max-width: 900px;
}

.banner-image {
  width: 100%;
  margin-left: 13%;
  margin-right:10%;
 
  /* height: 600px; */
  position: relative;
  left: -230px;
  /* border-radius: 10px; */
  object-fit: cover;
  display: block;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.banner-text-box {
  position: absolute;
  top: 67%;
  right: -150px;
  transform: translateY(-50%);
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  max-width: 550px;
  width: 550px;
  z-index: 2;
}

.banner-text-head {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 20px 0;
  color: #333;
  
  line-height: 1.2;
}

.banner-text-desc {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  color: #666;
  line-height: 1.6;
}

/* Decorative dots */
.dotted {
  position: absolute;
  width: 300px;
  height: auto;
  opacity: 0.8;
  z-index: 0;
}

.dotted-top-left {
  top: -50px;
  left: -50px;
  z-index:2;
}

.dotted-bottom-right {
  bottom: -50px;
  right: -50px;
}

/* Tablet styles */
@media (max-width: 1024px) {
  .banner-container {
    padding: 30px 15px;
  }
  
  .banner-text-box {
    right: -150px;
    width: 350px;
    max-width: 350px;
    padding: 25px;
  }
  
  .banner-text-head {
    font-size: 28px;
  }
  
  .banner-text-desc {
    font-size: 15px;
  }
  
  .dotted {
    width: 200px;
  }
  
  .dotted-top-left {
    top: -30px;
    left: -30px;
  }
  
  .dotted-bottom-right {
    bottom: -30px;
    right: -30px;
  }
}

/* Mobile styles */
@media (max-width: 768px) {
  .app-banner {
    min-height: auto;
  }
  
  .banner-container {
    padding: 20px 15px;
  }
  
  .banner-content {
    min-height: auto;
  }
  
  .image-section {
    max-width: 100%;
  }
  
  .banner-image {
    left: -20px;
    margin-bottom: 5%;
  }
  
  .banner-text-box {
    position: static;
    transform: none;
    width: 100%;
    max-width: 100%;
    margin: 20px 0 0 0;
    padding: 20px;
    right: auto;
    top: auto;
  }
  
  .banner-text-head {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  .banner-text-desc {
    font-size: 14px;
  }
  
  .dotted {
    width: 120px;
  }
  
  .dotted-top-left {
    top: -20px;
    left: -20px;
  }
  
  .dotted-bottom-right {
    bottom: -20px;
    right: -20px;
  }
}

/* Small mobile styles */
@media (max-width: 480px) {
  .banner-container {
    padding: 15px 10px;
  }
  
  .banner-content {
    gap: 20px;
  }
  
  .banner-text-box {
    padding: 15px;
    margin: 0 5px;
  }
  
  .banner-text-head {
    font-size: 20px;
    margin-bottom: 12px;
  }
  
  .banner-text-desc {
    font-size: 13px;
  }
  
  .dotted {
    width: 80px;
  }
  
  .dotted-top-left {
    top: -10px;
    left: -10px;
  }
  
  .dotted-bottom-right {
    bottom: -10px;
    right: -10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/how-it-works-components/AppBanner.vue